import React from "react";
import ContractsPage from "@/components/contracts/ContractsPage";
export default function AffiliateContracts() { return <ContractsPage role="affiliate" title="Contracts" />; }
